import React from 'react';
import Typography from "material-ui/styles/typography";
import {blueGrey50, indigo500, indigo700} from "material-ui/styles/colors";

export const muiTheme = {
  fontFamily: 'Roboto+Condensed, sans-serif',
  palette: {
    primary1Color: indigo500,
    primary2Color: indigo700
    //primary3Color: Colors.indigo100,
    //textColor: '#666',
  },
  toolbar: {
    backgroundColor: blueGrey50,
    height: 40,
    titleFontSize: 20
  },
  tableRowColumn: {
    height: 28,
    spacing: 16
  },
  tableHeaderColumn: {
    height: 28,
    spacing: 16
  },
  button: {
    height: 40,
    iconButtonSize: 40,
    minWidth: 40
    //textTransform: 'none'
  },
  menuItem: {
    height: 40
  },
  floatingActionButton: {
    /*  buttonSize: 56, */
    miniSize: 28
  },
  tabs: {
    backgroundColor: 'white',
    textColor: Typography.textLightBlack,
    selectedTextColor: Typography.textDarkBlack
  }
};



export const TabTemplate = React.createClass<Object, undefined>({

  render() {
    let styles = {
      'width': '100%',
      minHeight: 0,
      flexGrow: 1,
      display: (this.props.selected) ? "flex" : "none"
    };

    return (
      <div style={styles}>
        {this.props.children}
      </div>
    );
  }
});




// WEBPACK FOOTER //
// ./src/core/common/config/mui-theme.tsx